import { useCallback } from 'react';
import { useGetStreamingAcceleratorQuery } from '../../../../redux/api/fymAPI';

/** Streaming → Accelerator (design streaming-sections d1, d2): TuneCore only. */
export function useStreamingAccelerator(input: { accountId: number; days: number; skip: boolean }) {
  const { accountId, days, skip } = input;
  const read = useGetStreamingAcceleratorQuery({ accountId, days }, { skip });
  const { refetch } = read;
  const retry = useCallback(() => {
    refetch().catch(console.error);
  }, [refetch]);
  return { data: read.data, isLoading: read.isLoading, error: read.error, retry };
}
